import { SEA_BOUNDARY_INSET } from "@common/utils/seaBoundary";
import { Graphics } from "pixi.js";

/** Static red exclusion zone begins exactly at the authoritative lethal boundary. */
export function drawSeaBoundary(graphics: Graphics, width: number, height: number, scale: number): void {
    const inset = SEA_BOUNDARY_INSET;
    const outside = 2048;
    for (const [x, y, w, h] of [
        [-outside, -outside, width + outside * 2, outside + inset],
        [-outside, height - inset, width + outside * 2, outside + inset],
        [-outside, inset, outside + inset, height - inset * 2],
        [width - inset, inset, outside + inset, height - inset * 2]
    ]) graphics.rect(x * scale, y * scale, w * scale, h * scale).fill({ color: 0x941c35, alpha: 0.9 });
    const corners = [[inset, inset], [width - inset, inset], [width - inset, height - inset], [inset, height - inset]];
    for (let side = 0; side < 4; side++) {
        const [x, y] = corners[side], [ex, ey] = corners[(side + 1) % 4];
        graphics.moveTo(x * scale, y * scale).lineTo(ex * scale, ey * scale)
            .stroke({ color: 0xff5164, alpha: 1, width: Math.max(1, scale * 0.35) });
    }
}
